import { IconButton as MuiIconButton } from '@mui/material';
import { iconSizes, r, s } from '../../theme/tokens';
import { Icon } from './Icon';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import type { ReactElement } from 'react';

export type IconButtonProps = MuiIconButtonProps;

export const IconButton = ({
  sx,
  size = 'medium',
  children,
  ...rest
}: IconButtonProps): ReactElement => {
  const iconSize = size === 'small' ? 'sm' : size === 'large' ? 'lg' : 'md';
  const baseSize = iconSizes[iconSize];
  const sizeOffset = size === 'large' ? 16 : size === 'small' ? 8 : 12;
  const mergedSx = [
    {
      borderRadius: r('sm'),
      width: baseSize + sizeOffset,
      height: baseSize + sizeOffset,
      '&:focus-visible': { outline: '2px solid currentColor', outlineOffset: s('xs') },
    },
    sx,
  ].filter(Boolean) as MuiIconButtonProps['sx'];

  return (
    <MuiIconButton size={size} sx={mergedSx} {...rest}>
      <Icon size={iconSize}>{children}</Icon>
    </MuiIconButton>
  );
};
